import { createContext } from 'react';
import { MapContextType } from '../types';

const MapContext = createContext<MapContextType>({
  state: {},
  actions: {}
});

export default MapContext;
